module.exports = __webpack_public_path__ + "img/4.0d6c11f4.png";